import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {AuthenticationPanel} from "../AuthenticationPanel";
import {Messages} from "../../../../Messages";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {BasePanelPageStyle} from "../BasePanelPage";


class SubscribeAuthenticationPanelStyle extends BasePanelPageStyle {
    @styleRule
    message = this.themeProps.PAYWALL_MESSAGE_STYLE;
}

@registerStyle(SubscribeAuthenticationPanelStyle)
export class SubscribeAuthenticationPanel extends AuthenticationPanel {
    render() {
        return [
            Messages.subscribeInlineAuth1.toString().trim() ?
                <MessageElement message={Messages.subscribeInlineAuth1(iFrameMerchantService.getMerchant().name)}
                                className={this.styleSheet.message}/> : null,
            super.render()
        ];
    }
}
